import(/* webpackMode: "eager" */ "/app/app/docs/docs.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/docs/react-swagger.tsx");
